/*
 * Copyright (c) 2020.
 * ducnq
 */

import { SDK_CONFIG_CREATE_FAILURE, SDK_CONFIG_CREATE_SUCCESS, SDK_CONFIG_DETAILS_FAILURE, SDK_CONFIG_DETAILS_SUCCESS, SDK_CONFIG_UPDATE_FAILURE, SDK_CONFIG_UPDATE_SUCCESS } from "../../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const SdkConfigReducer = (state = {}, action) => {
  if (action.payload === undefined || action.payload === false) return state;

  switch (action.type) {
    case SDK_CONFIG_CREATE_SUCCESS:
    case SDK_CONFIG_DETAILS_SUCCESS:
    case SDK_CONFIG_UPDATE_SUCCESS:
    case SDK_CONFIG_CREATE_FAILURE:
    case SDK_CONFIG_UPDATE_FAILURE:
      return { ...state, action };
    default:
      return state;
  }
};

export { SdkConfigReducer };
